import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import AZMenuImpl from './az-menu.jsx';
import { noop } from 'mojito/utils';

/**
 * View which display the a-z navigation menu.
 *
 * @class AZMenu
 * @memberof Mojito.Modules
 */

/**
 * Callback to render search component instance.
 *
 * @param {boolean} isInitiallyActive - If true the search component suppose to be activated by default, false otherwise.
 * @callback Mojito.Modules.AZMenu.renderSearchComponent
 */

/**
 * Callback to render search component instance.
 *
 * @param {boolean} isInitiallyActive - If true the search overlay suppose to be activated by default, false otherwise.
 * @callback Mojito.Modules.AZMenu.renderSearchOverlay
 */

/**
 * AZMenu view prop types.
 *
 * @property {Mojito.Modules.AZMenu.onClose} [onClose = ()=>{}] - Callback called when menu is going to close.
 * @property {Mojito.Modules.AZMenu.renderSearchComponent} [renderSearchComponent = ()=>{}] - Function to be used to render search component instance.
 * @property {Mojito.Modules.AZMenu.renderSearchOverlay} [renderSearchOverlay = ()=>{}] - Function to be used to render search overlay instance.
 * @memberof Mojito.Modules.AZMenu
 */
const propTypes = {
    onClose: PropTypes.func,
    renderSearchComponent: PropTypes.func,
    renderSearchOverlay: PropTypes.func,
};

const defaultProps = {
    onClose: noop,
    renderSearchComponent: noop,
    renderSearchOverlay: noop,
};

export default MojitoCore.Presentation.UIView('AZMenu', AZMenuImpl, propTypes, defaultProps);
